import { BASE } from 'common/src/routes/BaseRoutes';
import { ProductFeatures } from 'common/src/types/enums/ProductFeatures.enum';
import { Products } from 'common/src/types/enums/Products.enum';

import useAuth from '../auth/useAuth';

interface IMenuItem {
  title: string;
  link: string;
}

/** @deprecated Temporary dual-layout rollout legacy menu builder. Remove when legacy layout is retired. */
export default function useProductMenuItemsLegacy(): IMenuItem[] {
  const { featureChecker, hasClientSystemAdminAccess } = useAuth();

  let menuItems: IMenuItem[];

  if (import.meta.env.VITE_PRODUCT_ID === Products.intervals) {
    menuItems = [
      {
        title: 'Portfolio',
        link: BASE.INTERVAL_DATA_PORTFOLIO,
      },
      {
        title: 'Electric',
        link: BASE.INTERVAL_DATA_ELECTRIC,
      },
      {
        title: 'Water',
        link: BASE.INTERVAL_DATA_WATER,
      },
      {
        title: 'Natural Gas',
        link: BASE.INTERVAL_DATA_NATURAL_GAS,
      },
    ];
  } else {
    menuItems = [
      {
        title: 'Summary',
        link: BASE.SUMMARY,
      },
      {
        title: 'Usage',
        link: BASE.USAGE,
      },
      {
        title: 'Costs',
        link: BASE.COST,
      },
      {
        title: 'Reports',
        link: BASE.REPORTS,
      },
      {
        title: 'Smart Meters',
        link: BASE.SMART_METERS,
      },
      {
        title: 'EV Charging',
        link: BASE.EV_CHARGING,
      },
      {
        title: 'Bill Automation',
        link: BASE.BILL_AUTOMATION,
      },
    ];
  }

  if (featureChecker.productFeatureEnabled(ProductFeatures.customDashboards)) {
    menuItems.push({
      title: 'Custom Dashboards',
      link: BASE.CUSTOM_DASHBOARDS,
    });
  }

  menuItems.push(
    ...[
      {
        title: 'Administration',
        link: BASE.ADMINISTRATION,
      },
      {
        title: 'Support',
        link: BASE.SUPPORT,
      },
    ],
  );

  if (hasClientSystemAdminAccess()) {
    menuItems.push({
      title: 'System Administration',
      link: BASE.SYSTEM_ADMINISTRATION,
    });
  }

  return menuItems;
}
